import { useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux'

import DataTable from '../../containers/DataTable'

import toolsAPICall from '../../app/apiCalls/toolsAPICall'
import { selectTool } from '../../app/store/actions/toolActions'
import { tools_list } from '../../app/apiEndpoints'

const ToolsTable = (props) => {
    const [data, setData] = useState([])

    const tableID = "tool"
    const tableFields = ["Name", "Client"]

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const rowID = useSelector((state) => state.currentToolID)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const onClick = (e) => {
        if(!props.showDetailsOnClick) return;
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        props.selectTool(rowID)
    }

    useMemo(() => {
        const getData = async () => {
            const data = await toolsAPICall(tools_list, {'requester': userID, 'company': companyID, 'status': (isSysadmin ? 0 : 1) })
            setData(data.tools)
        }
        getData()
    }, [userID, companyID, isSysadmin])

    const tableData = () => {
        if(data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach(row => {
            rows.push({'id': row.tool_id, 'values': [
                (props.showDetailsOnClick ? row.tool_name : `<a href="/tools/${row.tool_id}">${row.tool_name}</a>`),
                row.company_name,
                row.api_name
            ]});
        });
        return rows
    }


    return (
        <>
        <DataTable hover={true} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} onClick={onClick} currentRowID={rowID} />
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        selectTool: (id) => { 
            dispatch(selectTool(id))
        }
    }
  }

export default connect(state => ({...state}),mapDispatchToProps)(ToolsTable)